export { default } from "./paymentMethod";
